import script from "./SchoolDesignPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolDesignPreview.vue?vue&type=script&setup=true&lang=ts"

import "./SchoolDesignPreview.vue?vue&type=style&index=0&id=21df6b00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21df6b00"]])

export default __exports__